import { render, staticRenderFns } from "./AllConsolidatedProduct.vue?vue&type=template&id=55fd1e08"
import script from "./AllConsolidatedProduct.vue?vue&type=script&lang=js"
export * from "./AllConsolidatedProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports